var render = function render(){var _vm=this,_c=_vm._self._c;return _c('horizontal-nav',{attrs:{"set_sub_view":"","show_display":false,"items":_vm.items},on:{"setSelected":_vm.setSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }